/**
 * Confetti animation utility
 * Creates colorful confetti pieces that fall from the top of the screen
 */

const COLORS = [
  '#FFD700', // Gold
  '#FF69B4', // Pink
  '#00CED1', // Turquoise
  '#FF6347', // Tomato
  '#32CD32', // Lime Green
  '#9370DB', // Purple
  '#FF8C00', // Orange
];

/**
 * Create a single confetti piece
 * @param {number} x - Starting X position (0-100%)
 * @returns {HTMLElement} Confetti element
 */
function createConfettiPiece(x) {
  const piece = document.createElement('div');
  piece.className = 'confetti-piece';
  piece.style.left = `${x}%`;
  piece.style.backgroundColor = COLORS[Math.floor(Math.random() * COLORS.length)];
  piece.style.animationDuration = `${2 + Math.random() * 2}s`; // 2-4 seconds
  piece.style.animationDelay = `${Math.random() * 0.5}s`; // 0-0.5s delay

  return piece;
}

/**
 * Trigger confetti animation
 * @param {number} count - Number of confetti pieces (default: 30)
 * @param {boolean} enabled - Whether animations are enabled
 */
export function triggerConfetti(count = 30, enabled = true) {
  if (!enabled) return;

  const pieces = [];

  // Create confetti pieces spread across the screen
  for (let i = 0; i < count; i++) {
    const x = Math.random() * 100;
    const piece = createConfettiPiece(x);
    document.body.appendChild(piece);
    pieces.push(piece);
  }

  // Remove confetti pieces after animation completes
  setTimeout(() => {
    pieces.forEach(piece => {
      if (piece.parentNode) {
        piece.parentNode.removeChild(piece);
      }
    });
  }, 4000); // Max animation duration + buffer
}

/**
 * Trigger celebration confetti for major achievements
 * @param {boolean} enabled - Whether animations are enabled
 */
export function triggerCelebration(enabled = true) {
  triggerConfetti(50, enabled); // More confetti for celebrations!
}
